module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": (_vm.formData.id == 0 ? 'Nova Coluna' : 'Editar Coluna') + ' :: ' + _vm.tabela.nome,
      "modal": _vm.showForm,
      "loadingSave": _vm.config.loading.save,
      "onSave": _vm.salvar,
      "width": "99%"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.formItems
    }
  }, [(_vm.formData.id_tipo_campo == 210 || _vm.formData.id_tipo_campo == 211 || _vm.formData.id_tipo_campo == 212 || _vm.formData.id_tipo_campo == 217) ? _c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  }, [_c('Valores', {
    attrs: {
      "parent": this
    }
  })], 1) : _vm._e()])], 1)]), _vm._v(" "), _c('ed-table', {
    attrs: {
      "registerName": "Inserir Nova Coluna",
      "onRegister": (this.validarPermissao(571) ? _vm.onRegister : null),
      "onEdit": _vm.onEdit,
      "onDelete": _vm.onDelete,
      "onSearch": _vm.getTabelaDinamicaColuna,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.config.loading.content,
      "pagination": _vm.pagination,
      "response": _vm.response
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-623046f0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/ltcat/tabela-dinamica/coluna/index.vue
// module id = 1531
// module chunks = 45